<template>
  <div class="rap-tab-panel hide">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'rap-tab-panel',
};
</script>
<style lang="less" scoped>
.hide {
  visibility: hidden;
}
</style>
